import { Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { sectionListType } from '../types/TeacherSchedule';
import { TranslationsKeys } from '../../../locales/translations';

type UseSectionDetailsColumnProps = {
  goBack: () => void;
};

export const useSectionDetailsColumn = ({
  goBack,
}: UseSectionDetailsColumnProps) => {
  const { t } = useTranslation(TranslationsKeys.TEACHER_SCHEDULE);

  const column = useMemo(
    () => [
      {
        columnName: 'sectionName',
        headerText: (
          <div onClick={goBack} className="cursor-pointer">
            <Icon name="chevron_left" color="inherit" size={12} />
            <span className="pl-2">{t(`goBack`)}</span>
          </div>
        ),
        cellFormat: ({ row }: { row: sectionListType }) => (
          <Row
            key={row.courseName + '-' + row.sectionName}
            className="section-box text-small"
          >
            <Col xs={12} md={3} className="mb-3">
              <span className="fw-700 text-dark">{t(`section`)}</span>
              <br />
              <span>{row.sectionName}</span>
            </Col>
            <Col xs={12} md={3} className="mb-3">
              <span className="fw-700 text-dark">{t(`teacher`)}</span>
              <br />
              <div>
                {row.teachers.map((name) => (
                  <div key={name}>
                    <span>{name}</span>
                    <br />
                  </div>
                ))}
              </div>
            </Col>
            <Col xs={8} md={3} className="mb-3 hours-list">
              <span className="fw-700 text-dark">{t(`schedule`)}</span>
              <br />
              <div>
                {row.schedules.map((schedule) => (
                  <div key={`${schedule.day}-${schedule.startHour}`}>
                    <span className="mr-2 text-uppercase">{schedule.day}</span>
                    <span>{`${schedule.startHour}-${schedule.endHour}`}</span>
                  </div>
                ))}
              </div>
            </Col>
            <Col xs={4} md={3} className="mb-3 hours-list">
              <span className="fw-700 text-dark">{t(`classroom`)}</span>
              <br />
              <div>
                {row.schedules.map((schedule) => (
                  <div
                    key={`${schedule.day}-${schedule.startHour}-${schedule.classroom}`}
                  >
                    <span>{schedule.classroom}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        ),
      },
    ],
    [goBack, t],
  );

  return column;
};
